import {
  DoorStickerTemplate,
  FlyerTemplate,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';

export default {
  title: 'Drukproducten',
  types: {
    [PolygraphyProductType.Flyer]: {
      name: 'Flyers',
      templates: {
        [FlyerTemplate.One]: '#1 🆕',
        [FlyerTemplate.Two]: '#2  🆕',
        [FlyerTemplate.Three]: '#3',
        [FlyerTemplate.Four]: '#4',
      },
    },
    [PolygraphyProductType.Sticker]: {
      name: 'Stickers',
      templates: {
        [StickerTemplate.One]: '#1 🆕',
      },
    },
    [PolygraphyProductType.DoorSticker]: {
      name: 'Deurstickers',
      templates: {
        [DoorStickerTemplate.One]: '#1 🆕',
        [DoorStickerTemplate.Two]: '#2 🆕',
      },
    },
    [PolygraphyProductType.Custom]: {
      name: 'Aangepaste drukproducten',
    },
  },
  buttons: {
    order: 'Nieuwe bestelling',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
